export default "/images/shikdikPremier.svg?3e02f2a420d05037b0699e1b3bcedb79";